import React from "react";
import { Box } from "@material-ui/core";
import BrokenImageIcon from "@material-ui/icons/BrokenImage";

function isValidHttpUrl(value) {
  if (!value) return false;
  try {
    const u = new URL(value);
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

/**
 * ImagePreview (semplice)
 *
 * Props:
 * - url: string
 * - alt?: string
 * - variant?: "form" | "dialog" (default "form")
 * - maxHeight?: number|string
 *    - form default: 140
 *    - dialog default: "70vh"
 * - maxWidth?: number|string (default "100%")
 * - borderRadius?: number (default 8)
 */
export default function ImagePreview({
  url,
  alt = "",
  variant = "form",
  maxHeight,
  maxWidth = "100%",
  borderRadius = 8,
}) {
  const src = (url || "").trim();
  const valid = isValidHttpUrl(src);

  const [error, setError] = React.useState(false);

  React.useEffect(() => {
    setError(false); // reset quando cambia url
  }, [src]);

  if (!valid) return null;

  const effectiveMaxHeight = maxHeight ?? (variant === "dialog" ? "70vh" : 140);

  return (
    <Box
      mt={1}
      display="flex"
      justifyContent={variant === "dialog" ? "center" : "flex-start"}
    >
      {!error ? (
        <img
          src={src}
          alt={alt}
          onError={() => setError(true)}
          style={{
            display: "block",
            maxHeight: effectiveMaxHeight,
            maxWidth: maxWidth,
            width: "auto", // <- larghezza proporzionale
            height: "auto", // <- no stretching
            objectFit: "contain", // <- no taglio
            borderRadius,
          }}
        />
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{
            border: "1px dashed rgba(0,0,0,0.25)",
            borderRadius,
            height: variant === "dialog" ? 160 : effectiveMaxHeight,
            width: variant === "dialog" ? 240 : 200,
          }}
        >
          <BrokenImageIcon fontSize="small" />
        </Box>
      )}
    </Box>
  );
}
